import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = not authed, object = authed
  const [actingOrgId, setActingOrgId] = useState(localStorage.getItem("acting_org_id") || "");

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch (e) {
      setUser(false);
      return false;
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {}
    localStorage.removeItem("acting_org_id");
    setActingOrgId("");
    setUser(false);
  };

  const setActingOrg = (orgId) => {
    if (orgId) localStorage.setItem("acting_org_id", orgId);
    else localStorage.removeItem("acting_org_id");
    setActingOrgId(orgId || "");
  };

  const roles = user?.roles || [];
  const isManagerOnly = roles.includes("center_manager") && !roles.includes("org_admin") && !roles.includes("super_admin");

  return (
    <AuthContext.Provider
      value={{ user, setUser, refresh, logout, actingOrgId, setActingOrg, isManagerOnly }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
